import {Component, inject} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {ActivatedRoute, Router} from "@angular/router";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {IBroadcastNotification} from "../../../interfaces/notifications/IBroadcastNotification";

@Component({
  selector: 'app-broadcast-notification-actions',
  standalone: true,
  imports: [
    HasPermissionDirective,
    MatMenuTrigger,
    MatIconButton,
    MatIcon,
    MatTooltip,
    MatMenu,
    MatMenuItem
  ],
  templateUrl: './broadcast-notification-settings.component.html'
})
export class BroadcastNotificationSettingsComponent implements ICellRendererAngularComp {

  public notification!: IBroadcastNotification;
  public permissionTypes = PermissionTypes;

  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);

  agInit(params: ICellRendererParams): void {
    this.notification = params.data;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onEditClick() {
    const currentGameId = this.route.snapshot.params['gameId'];

    if (currentGameId) {
      this.router.navigate([`/${currentGameId}/edit-broadcast-notification`, this.notification.Id]);
    } else {
      this.router.navigate(['/edit-broadcast-notification', this.notification.Id]);
    }
  }
}
